import {makeReactContext} from 'lib/makeReactContext';

interface CaptionEditableItemContextValue {
  setIsImageEditorOpen: (isOpen: boolean) => void;
  isImageEditorOpen: boolean;
}

export function getCaptionEditableItemContextFallback(): CaptionEditableItemContextValue {
  return {
    setIsImageEditorOpen: (isOpen) => {},
    isImageEditorOpen: false,
  };
}

export const CaptionEditableItemContext = makeReactContext<CaptionEditableItemContextValue>(
  getCaptionEditableItemContextFallback,
  'CaptionEditableItemContext'
);
